<template>
  <a
    :id="elementId"
    class="jr-link me-2"
    :href="null"
    @click="clickHandler(props.linkText)"
    >{{ props.linkText }}</a
  >
</template>

<script setup>
// import appUtils from '../utils/appUtils.js';
import { defineProps, defineEmits } from 'vue';

const props = defineProps(['elementId', 'linkText']);
const emit = defineEmits(['clickHandler']);

function clickHandler(par) {
  emit('clickHandler', par);
}
</script>
